export default "__VITE_ASSET__DDGhSY$5__"